import { FORMER_CUSTOMER_CREATE_CASE_SUCCESS } from "../actions/types";

const initialState = {
  firstName: "",
  lastName: "",
  status: "",
  formerId: "",
  accountInfo: [],
  caseId:"",
  isCasePending: false,
  availablePaths:""
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FORMER_CUSTOMER_CREATE_CASE_SUCCESS:
      return {
        ...state,
        ...payload,
            };
    default:
      return state;
  }
};
